import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import {
  decimalInvertedReportFormatter,
  percentageReportFormatter,
} from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function DailySummaryChart() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  const [reportType, setReportType] = useState(0);
  const onReportTypeChange = useCallback(
    (event) => setReportType(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [league, setLeague] = useState("");
  const onLeagueChanged = useCallback((l) => setLeague(l), []);
  const { values: leagues } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/League/League_GetAllLeagues`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="League"
          name="name"
          data={leagues}
          placeholder="DataFormatter"
          setSelectValue={onLeagueChanged}
          startValue={""}
        />

        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Office"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Date"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Report Type">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={reportType}
                onChange={onReportTypeChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Default"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Details"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Daily Summary Chart Report"
        groupBy="groupName"
        getUrl={() => "/Reports/Report_Daily_Summary_Chart"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Group: group,
          Office: office,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Distributor: distributor,
          Player: player,
          League: league,
          CreditLimit: 0,
        })}
        getProcess={(data) =>
          data.map((item) => {
            const percent =
              Math.round(
                (item.sportWinLoss / item.sportVolume + Number.EPSILON) * 10000
              ) / 100;

            return {
              ...item,
              sportPercent: Number.isNaN(percent) ? 0 : percent,
              total:
                item.sportWinLoss +
                item.horseWinLoss +
                item.casinoWinLoss +
                item.sportAdjust +
                item.horseAdjust,
            };
          })
        }
        getTotals={(data) => {
          const sportWinLoss = data.reduce(
            (acc, item) => acc + item.sportWinLoss,
            0
          );
          const sportVolume = data.reduce(
            (acc, item) => acc + item.sportVolume,
            0
          );
          const sportPercent = Math.ceil((sportWinLoss / sportVolume) * 100);

          return {
            dayDate: "Sub Totals",
            sportPlayers: data.reduce(
              (acc, item) => acc + item.sportPlayers,
              0
            ),
            sportWagers: data.reduce((acc, item) => acc + item.sportWagers, 0),
            sportVolume,
            sportWinLoss,
            sportPercent,
            horseWinLoss: data.reduce(
              (acc, item) => acc + item.horseWinLoss,
              0
            ),
            casinoWinLoss: data.reduce(
              (acc, item) => acc + item.casinoWinLoss,
              0
            ),
            total: data.reduce((acc, item) => acc + item.total, 0),
            cashInOut: data.reduce((acc, item) => acc + item.cashInOut, 0),
          };
        }}
        getGlobalTotals={(data) => {
          const sportWinLoss = data.reduce(
            (acc, item) => acc + item.sportWinLoss,
            0
          );
          const sportVolume = data.reduce(
            (acc, item) => acc + item.sportVolume,
            0
          );
          const sportPercent = Math.ceil((sportWinLoss / sportVolume) * 100);

          return {
            dayDate: "Totals",
            sportPlayers: data.reduce(
              (acc, item) => acc + item.sportPlayers,
              0
            ),
            sportWagers: data.reduce((acc, item) => acc + item.sportWagers, 0),
            sportVolume,
            sportWinLoss,
            sportPercent,
            horseWinLoss: data.reduce(
              (acc, item) => acc + item.horseWinLoss,
              0
            ),
            casinoWinLoss: data.reduce(
              (acc, item) => acc + item.casinoWinLoss,
              0
            ),
            total: data.reduce((acc, item) => acc + item.total, 0),
            cashInOut: data.reduce((acc, item) => acc + item.cashInOut, 0),
          };
        }}
      >
        {reportType === 0
          ? [
            <TableHeaderColumn
              dataSort
              row="0"
              colSpan="3"
            ></TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              className="table-header-groupped-left table-header-groupped-right"
              row="0"
              colSpan="3"
              dataAlign="center"
              headerAlign="center"
            >
              Sports
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              row="0"
              colSpan="4"
            ></TableHeaderColumn>,
            <TableHeaderColumn dataSort dataField="Id" isKey hidden row="1">
              Id
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="dayDate"
              dataFormat={dateReportFormatter}
              row="1"
            >
              Date
            </TableHeaderColumn>,
            <TableHeaderColumn dataSort dataField="sportPlayers" row="1">
              Players
            </TableHeaderColumn>,
            <TableHeaderColumn dataSort dataField="sportWagers" row="1">
              Wagers
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              className="table-header-groupped-left"
              dataField="sportVolume"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Volume
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="sportWinLoss"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Win/Losses
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              className="table-header-groupped-right"
              dataField="sportPercent"
              row="1"
              dataFormat={percentageReportFormatter}
            >
              Percents
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="horseWinLoss"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Horses W/L
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="casinoWinLoss"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Casino W/L
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="total"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Total
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="cashInOut"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Cash In/Out
            </TableHeaderColumn>,
          ]
          : [
            <TableHeaderColumn
              dataSort
              row="0"
              colSpan="1"
            ></TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              className="table-header-groupped-left table-header-groupped-right"
              row="0"
              colSpan="6"
              dataAlign="center"
              headerAlign="center"
            >
              Sports
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              row="0"
              colSpan="1"
            ></TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              className="table-header-groupped-left table-header-groupped-right"
              row="0"
              colSpan="5"
              dataAlign="center"
              headerAlign="center"
            >
              Horses
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              row="0"
              colSpan="3"
            ></TableHeaderColumn>,
            <TableHeaderColumn dataSort dataField="Id" isKey hidden row="1">
              Id
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="dayDate"
              dataFormat={dateReportFormatter}
              row="1"
            >
              Date
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="sportPlayers"
              row="1"
              className="table-header-groupped-left"
            >
              Players
            </TableHeaderColumn>,
            <TableHeaderColumn dataSort dataField="sportWagers" row="1">
              Wagers
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="sportVolume"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Volume
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="sportWinLoss"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Sports
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="sportAdjust"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Adj
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              className="table-header-groupped-right"
              dataField="sportPercent"
              row="1"
              dataFormat={percentageReportFormatter}
            >
              Percents
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="casinoWinLoss"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Casino
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              className="table-header-groupped-left"
              dataField="horsePlayers"
              row="1"
            >
              Players
            </TableHeaderColumn>,
            <TableHeaderColumn dataSort dataField="horseWagers" row="1">
              Wagers
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="horseVolume"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Horse Volume
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="horseWinLoss"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Horses
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              className="table-header-groupped-right"
              dataField="horseAdjust"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Adj
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="sumTaxAmount"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Tax
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="total"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Total
            </TableHeaderColumn>,
            <TableHeaderColumn
              dataSort
              dataField="cashInOut"
              row="1"
              dataFormat={decimalInvertedReportFormatter}
            >
              Cash In/Out
            </TableHeaderColumn>,
          ]}
      </Report>
    </div>
  );
}

export default DailySummaryChart;
